// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Check inventory'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li permissions="CHK_INCOMING_CHECK_READ"
          ng-class="{'active': \$ctrl.displayMode === 'INCOMING'}" >
        <a data-target="#tab-incoming-checks" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('INCOMING')">
          <span>Outward</span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'OUTGOING'}">
        <a data-target="#tab-outgoing-checks" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('OUTGOING')">
          <span>Inward</span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'ON_US'}">
        <a data-target="#tab-on-us-checks" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('ON_US')">
          <span>On us</span>
        </a>
      </li>
      <li ng-class="{'active': false}" class="disabled">
        <a disabled>
          <span>Cashier</span>
        </a>
      </li>
      <li ng-class="{'active': \$ctrl.displayMode === 'LOAN_PDC'}">
        <a data-target="#tab-loan-pdc-checks" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('LOAN_PDC')">
          <span>Loan PDC</span>
        </a>
      </li>
    </ul>
  </div>



  <incoming-checks-list ng-if="\$ctrl.displayMode === 'INCOMING'"></incoming-checks-list>
  <outgoing-checks-list ng-if="\$ctrl.displayMode === 'OUTGOING'"></outgoing-checks-list>
  <on-us-checks-list ng-if="\$ctrl.displayMode === 'ON_US'"></on-us-checks-list>
  <loan-pdc-list ng-if="\$ctrl.displayMode === 'LOAN_PDC'"></loan-pdc-list>
</section>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/check/checks-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;